import { BaseQuery } from './BaseQuery';
import { IExecutionOptions } from '../models/query';
import { getUTCDateString, getUTCFullYear } from '../utils/date';

export class DynamicQuery extends BaseQuery {
	getRawValue<T = any>(executionOptions: IExecutionOptions): T {
		const { key } = this.options;
		let response: any;
		switch (key) {
			case 'date':
				response = getUTCDateString();
				break;
			case 'year':
				response = getUTCFullYear();
				break;
		}
		return response;
	}
}